import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Content, Overlay, Portal, Root, Title } from '@radix-ui/react-dialog';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import classNames from 'classnames';
import styles from './modal.module.scss';
export const Modal = ({ children, footerContent, isOpen, onPointerDownOutside, title })=>/*#__PURE__*/ _jsx(Root, {
        open: isOpen,
        children: /*#__PURE__*/ _jsxs(Portal, {
            children: [
                /*#__PURE__*/ _jsx(Overlay, {
                    className: styles.overlay
                }),
                /*#__PURE__*/ _jsxs(Content, {
                    className: classNames(styles['modal-surface']),
                    onPointerDownOutside: onPointerDownOutside,
                    children: [
                        /*#__PURE__*/ _jsx(VisuallyHidden, {
                            children: /*#__PURE__*/ _jsx(Title, {
                                children: title
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: styles['content-wrapper'],
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: styles['modal-content'],
                                    children: children
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: styles['bottom-shadow-curtain']
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("footer", {
                            className: styles['modal-footer'],
                            children: footerContent
                        })
                    ]
                })
            ]
        })
    });

//# sourceMappingURL=modal.js.map